import { useAuthFetchWithResult } from '@e3dc-react/shell/Hooks/AuthFetch'
import { subscribeForPushNotifications, unsubscribeFromPushNotifications } from '../api'
import { useCallback } from 'react'
import { useIsWebviewMode } from 'src/Hooks'

interface UsePushNotificationHandler {
  handlePushNotificationsAfterLogin: () => void
  handlePushNotificationsBeforeLogout: () => void
}

/**
 * Custom hook for handling push notification subscription
 * @param pushToken - token got from expo app which is used to send push notification to specific device and app
 */
const usePushNotificationHandler = (pushToken?: string): UsePushNotificationHandler => {
  const authFetch = useAuthFetchWithResult()
  const isWebView = useIsWebviewMode()

  const handlePushNotificationsAfterLogin = useCallback((): void => {
    if (pushToken && isWebView) {
      subscribeForPushNotifications(pushToken, authFetch)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushToken, isWebView])

  const handlePushNotificationsBeforeLogout = useCallback((): void => {
    if (pushToken && isWebView) {
      unsubscribeFromPushNotifications(pushToken, authFetch)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pushToken, isWebView])

  return { handlePushNotificationsAfterLogin, handlePushNotificationsBeforeLogout }
}

export default usePushNotificationHandler
